// extracted by mini-css-extract-plugin
export default {"filter":"ZOe09dWG"};